module.exports = __webpack_public_path__ + "img/zz-level-ur3.244dbc23.png";